export { default } from './PageDashboard.vue'
